export default [
    {
        header: true,
        title: ''
    },
    {
        title: 'ホーム（案件管理）',
        icon: 'home',
        href: '/company/dashboard',
    },
    {
        title: '新規案件登録',
        icon: 'clipboard',
        href: '/company/register/project',
    },
    {
        title: '職人検索',
        icon: 'user-tag',
        href: '/company/search-worker',
    },
    {
        title: '会社情報編集',
        icon: 'edit',
        href: '/company/edit-profile',
    },
    {
        title: 'メッセージ',
        icon: 'comments',
        href: '/company/messager',
    },
    {
        title: 'お気に入り',
        icon: 'heart',
        href: '/company/favorite-artisan',
    },
    {
        title: '支払い',
        icon: 'yen-sign',
        href: '/company/payment',
    },
    {
        title: '各種設定',
        icon: 'cog',
        href: '/company/setting',
    },
    {
        title: 'お問い合わせ',
        icon: 'envelope',
        href: '/company/contact',
    },
    {
        title: 'ヘルプ',
        icon: 'question-circle',
        href: '/company/help',
    },
]
